/**
 * Indicate that we want to insert styleguide data into the store.
 * @type {string}
 */
export const INSERT_STYLEGUIDE_DATA = 'INSERT_STYLEGUIDE_DATA';
